import "smelte/src/tailwind.css";
import App from './App.svelte';

function check_and_redirect() {
	// if using the old site (bit.ly redirecting to gitlab), then redirect to the new site
	if (window.location.hostname.includes("gitlab", 0)) {
		window.location = "https://bluetoolk.it/";
	};
};

check_and_redirect();

const app = new App({
	target: document.getElementById("root"),
	props: {
	}
});

export default app;
